module.exports = __webpack_public_path__ + "posture/static/img/leg_o_normal.23569fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/leg_o_normal.png
// module id = Pnl9
// module chunks = 1